import React from "react";
import Chart from "react-apexcharts";
import { Pagination, Box, Typography } from "@mui/material";

const VisitorChartWithPagination = ({
  setCurrentPage,
  currentPage,
  totalPages,
  chartData,
  showPagination
}) => {
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };
  const showBarChart = chartData?.series?.length === 0;
  return (
    <>
      {showBarChart === true ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            height: "400px",
          }}
        >
          <Typography
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            {" "}
            No Records{" "}
          </Typography>
        </Box>
      ) : (
        <Box>
          <Chart
            options={chartData?.options}
            series={chartData?.series}
            type={chartData?.type || "bar"}
            height={ showPagination ? "400" : "430"}
            width={"100%"}
          />
         { showPagination && (<Box
            mb={1}
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Pagination
              count={totalPages} 
              page={currentPage}
              onChange={handlePageChange}
              color="primary"
              siblingCount={0}
              boundaryCount={0}
              showFirstButton
              showLastButton
            />
            <Typography variant="body2" ml={1} mr={2}>
              Page {currentPage} of {totalPages}
            </Typography>
          </Box>)}
        </Box>
      )}
    </>
  );
};

export default VisitorChartWithPagination;
